<template>
  <span v-for="(part, index) in parts" :key="index" :class="part.highlight ? 'font-semibold' : ''">{{ part.text }}</span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  text: {
    type: String,
    default: ''
  },
  query: {
    type: String,
    default: ''
  }
})

// Safely split text into parts for highlighting without using v-html
const parts = computed(() => {
  if (!props.text) return [{ text: '', highlight: false }]
  if (!props.query || props.query.trim() === '') {
    return [{ text: props.text, highlight: false }]
  }

  const escapedQuery = escapeRegex(props.query)
  const regex = new RegExp(`(${escapedQuery})`, 'gi')
  const segments = props.text.split(regex)
  
  // Use case-insensitive comparison instead of regex.test() to avoid lastIndex mutation
  const queryLower = props.query.toLowerCase()
  
  return segments.map(segment => ({
    text: segment,
    highlight: segment.toLowerCase() === queryLower
  }))
})

// Escape special regex characters
const escapeRegex = (str) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
</script>

<style scoped>
.font-semibold {
  font-weight: 600;
}
</style>
